var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166.953,
    height: 215.131,
    viewBox: "0 0 166.953 215.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.179,
    y1: -0.302,
    x2: 1.651,
    y2: 1.588,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f3061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82140"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(419.818 -46.406)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-382.1,253.053q-18.635-8.479-27.876-21.362t-9.847-26.513A6.166,6.166,0,0,1-418,200.633a6.171,6.171,0,0,1,4.545-1.819h27.876q6.66,0,9.09,6.061,6.662,21.519,40,21.514,18.479,0,28.936-8.485t10.453-24.24q0-15.75-9.544-22.877t-28.027-7.119h-31.209a7,7,0,0,1-5.151-2.121,7,7,0,0,1-2.121-5.152V143.367a11.288,11.288,0,0,1,3.939-9.092l53.934-52.72h-86.355a7.364,7.364,0,0,1-5.454-2.121,7,7,0,0,1-2.121-5.151V53.98a7.382,7.382,0,0,1,2.121-5.453,7.387,7.387,0,0,1,5.454-2.121h130.29a7.4,7.4,0,0,1,5.453,2.121,7.4,7.4,0,0,1,2.122,5.453V72.465a10.628,10.628,0,0,1-3.939,8.484l-52.116,53.631,3.636.3q29.088,2.429,46.207,17.574t17.12,43.328q0,20-10.757,34.846t-29.694,22.877q-18.939,8.023-43.177,8.029Q-363.466,261.537-382.1,253.053Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.d7a6aa8806ffdb44ea4e8a4531286e7b.svg";
export { ForwardRef as ReactComponent };